import { writable } from 'svelte/store';

// export const saved_wifi_neworks = writable(
// 	JSON.parse(localStorage.getItem('saved_wifi_neworks'))
// );
// saved_wifi_neworks.subscribe(wifi_networks =>
// 	localStorage.setItem('saved_wifi_neworks', JSON.stringify(wifi_networks))
// );

function create_saved_wifi_neworks() {
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('saved_wifi_neworks')) || {},
	);

	return {
		subscribe,
		set,
		update: (email, data: { ssid: string; pass: string }) =>
			update((saved_wifi_neworks) => {
				return { ...saved_wifi_neworks, [email]: data };
			}),
		remove: (email) =>
			update((saved_wifi_neworks) => {
				delete saved_wifi_neworks[email];
				return saved_wifi_neworks;
			}),
		reset: () => set({}),
	};
}
export const saved_wifi_neworks = create_saved_wifi_neworks();
saved_wifi_neworks.subscribe((wifi_networks) =>
	localStorage.setItem('saved_wifi_neworks', JSON.stringify(wifi_networks)),
);
